<template lang="pug">
#tabela-dados-financeiros-pf
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    el-collapse(v-model='activeCollapseItem')
        el-collapse-item(:title="$t('mensagens.preAnaliseCredito.dadosFinanceiros.informacoesProfissionais')", name='0')
            template(slot='title')
                | {{ $t('mensagens.preAnaliseCredito.dadosFinanceiros.informacoesProfissionais') }}
                i.mdi.mdi-minus-circle.ml-2(
                    v-if='!dados["pessoa-renda-estimada-v2"]'
                )(
                    style='font-size: 20px; color: #686868'
                )
            div(v-if='dados["pessoa-renda-estimada-v2"]')
                BaseInfoBlock(
                    :titulos-info-block='["Valor da Renda Estimada no ano"]',
                    :valores-info-block='[dados["pessoa-renda-estimada-v2"].faixaRenda]',
                    :valor-moeda='true'
                )
            el-alert(
                v-if='!dados["pessoa-renda-estimada-v2"]',
                :title="$t('mensagens.preAnaliseCredito.dadosFinanceiros.naoHaRegistroParaInfoProfissionais')",
                type='warning',
                :closable='false'
            )

    el-collapse(v-model='activeCollapseItem')
        el-collapse-item(
            :title="$t('mensagens.preAnaliseCredito.dadosFinanceiros.impostoDeRendaPessoaFisica')",
            name='1'
        )
            template(slot='title')
                | {{ $t('mensagens.preAnaliseCredito.dadosFinanceiros.impostoDeRendaPessoaFisica') }}
                i.mdi.mdi-minus-circle.ml-2(
                    v-if='!dados.irpfRestituicao && !dados.irpfRestituicao.exercicios'
                )(
                    style='font-size: 20px; color: #686868'
                )
            el-table(
                v-if='dados.irpfRestituicao && dados.irpfRestituicao.exercicios',
                :data='dados.irpfRestituicao.exercicios',
                :default-sort='{ prop: "anoExercicio", order: "descending" }',
                style='width: 100%; max-height: 300px; overflow: auto',
                class="fixed-header-table",
                stripe
            )
                el-table-column(
                    :label="$t('mensagens.preAnaliseCredito.dadosFinanceiros.anoRecebimentoRestituicaoImpostoDeRenda')",
                    prop='anoExercicio',
                    align='left',
                    sortable,
                    min-width='125px'
                )
                el-table-column(
                    :label="$t('mensagens.preAnaliseCredito.dadosFinanceiros.banco')",
                    prop='nomeBanco',
                    align='left',
                    :formatter='emptyFormatter',
                    min-width='150px'
                )
                el-table-column(
                    :label="$t('mensagens.preAnaliseCredito.dadosFinanceiros.agencia')",
                    prop='numAgencia',
                    align='left',
                    :formatter='emptyFormatter',
                    min-width='50px'
                )
                el-table-column(
                    :label="$t('mensagens.preAnaliseCredito.dadosFinanceiros.situacaoContibuinteCadastradaPelaReceita')",
                    prop='situacao',
                    align='left',
                    min-width='300px'
                )
            el-alert(
                v-else-if='!dados.irpfRestituicao && !dados.irpfRestituicao.exercicios',
                :title="$t('mensagens.preAnaliseCredito.dadosFinanceiros.naoHaRegistroParaIrpf')",
                type='warning',
                :closable='false'
            )
            .tabela-rodape-somatorio(
                v-if='dados.irpfRestituicao && dados.irpfRestituicao.exercicios'
            )
                p {{ dados.irpfRestituicao.exercicios.length }} {{ $t('mensagens.preAnaliseCredito.dadosFinanceiros.declaracoes') }}
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/components/preAnaliseCredito/BaseTableHeader';
import BaseInfoBlock from '@/components/preAnaliseCredito/BaseInfoBlock';
import BaseModalVisualizarInfos from '@/components/preAnaliseCredito/BaseModalVisualizarInfos';

export default {
    name: 'TabelaDadosFinanceirosPf',

    components: {
        BaseTableHeader,
        BaseInfoBlock,
        BaseModalVisualizarInfos
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => {}
        }
    },

    data() {
        return {
            activeCollapseItem: ['0']
        };
    },

    methods: {
        formatarCep(row, column, cep, index) {
            return formatters.formatarCEP(cep);
        },
        isEmpty(row, column, data, index) {
            return formatters.isEmpty(data);
        },
        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        formatCpfCnpjTableColumn(row, column, cpfCnpj, index) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        tratarEndereco(endereco) {
            return endereco.municipio + '-' + endereco.uf;
        },
        formatValorBRL(valor) {
            return 'R$ ' + formatters.formatNumber(valor, 2);
        },
        emptyFormatter(row, column, cellValue, index) {
            if (!cellValue) {
                return '- -';
            }
            return cellValue;
        }
    }
};
</script>

<style lang="scss">
#tabela-dados-financeiros-pf {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    .fixed-header-table .el-table__header-wrapper {
        position: sticky;
        top: 0;
        z-index: 1;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .table-infos-profissionais {
        height: 100%;
        width: 100%;

        .action-button {
            cursor: pointer;
        }
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }

    .el-collapse-item__content {
        padding-bottom: 5px !important;
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 21px;
        padding-top: 17px;
    }
}
</style>
